// @ts-check

import { useState } from 'react';
import USER from '../ts/profileEditorEnum';

/**
 * @function useProfileBadge
 * @param {(name: string, payload: any) => void} onHandle
 * @returns {object}
 */
function useProfileBadge(onHandle) {
	const [canNotSave, setCanNotSave] = useState(true);
	const [openImg, setOpenImg] = useState(false);
	const [preview, setPreview] = useState('');
	const [file, setFile] = useState({});

	/**
	 * @function onOpenImg
	 * @param {boolean} status
	 * @returns {void}
	 */
	const onOpenImg = (status) => {
		!status && onReset();
		setOpenImg(status);
	};

	const onReset = () => {
		setPreview('');
		setFile({});
		setCanNotSave(true);
	};

	/**
	 * @function onHandleButton
	 * @param {string} name
	 * @returns {void}
	 */
	const onHandleButton = (name) => {
		if (name === 'reset') {
			onReset();
		} else if (name === 'chose') {
			onHandle(USER.IMAGE, { preview, file });
			onReset();
			onOpenImg(false);
		}
	};

	/**
	 * @function onHandleImg
	 * @param {React.ChangeEvent<HTMLInputElement>} e
	 * @returns {Promise<void>}
	 */
	const onHandleImg = (e) => {
		if (e.target.files && e.target.files[0]) {
			const reader = new FileReader();
			reader.readAsDataURL(e.target.files[0]);
			return new Promise((resolve) => {
				reader.onload = () => {
					setFile(e.target.files[0]);
					setPreview(reader.result.toString());
					setCanNotSave(false);
					resolve();
				};
			});
		}
	};

	const state = { canNotSave, openImg, preview };

	const handler = { onOpenImg, onHandleButton, onHandleImg };

	return { state, handler };
}

export default useProfileBadge;
